import { PublicAvailability } from '../../../index';
import { Nillable } from '@web/utils';

export class PublicCartItemStatus {
  public constructor(
    private readonly data: {
      availability: PublicAvailability;
      maxQuantityPerOrder: Nillable<number>;
      unavailableMessage: Nillable<string>;
    },
  ) {}

  public get availability(): PublicAvailability {
    return this.data.availability;
  }

  public get maxQuantityPerOrder(): Nillable<number> {
    return this.data.maxQuantityPerOrder;
  }

  public get unavailableMessage(): Nillable<string> {
    return this.data.unavailableMessage;
  }

  public get onlySingleElement(): boolean {
    return this.maxQuantityPerOrder === 1;
  }
}
